<template>
<div class="modal" tabindex="-1" id="create-timeslice-minify-modal">
    <div class="modal-dialog  modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-custom">
                <div class="row d-flex justify-content-between">
                    <h4 class="col-6">Create your &nbsp; <h3>Minified TimeCapsule</h3> </h4>&nbsp;<h4> You Today: {{getTodayFormat()}}</h4>

                </div>
                <div class="row d-flex justify-content-between">
 <button type="button" @click="cancel" class="close col-2" title="Close" data-dismiss="modal" aria-label="Close">
 <span aria-hidden="true">&times;</span>
                </button>
                <small  style="margin-left:2em; margin-right:2em;">(<strong>Instructions:</strong> Create a Time-Capsule of You, as you are today.</b>

                   <br/><br/>Begin with a current image of yourself.<br/>A few sentences: your current status, and your Vision for You.)</small>

                </div>
            </div>
            <div class="modal-body">
                <div class="row" >
                    <div class="col">
                    <h2 class="bg-secondary text-center" v-if="timeslice" v-html="'<strong>Record your Time-Capsule:</strong> ' + getTodayFormat()"></h2>
                <!-- <div class="col-12">
                provide this option later: ability to save as video or image: leave as default image
                    <label for="visual_option">My Visual Record Type:&nbsp;</label>

<input id="videoImageSwitch" type="checkbox" @change="switchVideoImg">
<span v-if="videoOption">&nbsp;(Video</span><span v-if="!videoOption">&nbsp;(Image</span>&nbsp; option selected)</span>
                </div>-->
               <div class="row d-flex justify-content-center"  v-if="!videoOption">
                      <label class="col-2 text-right" for="videourl">Upload image:&nbsp;</label>
                             <!-- @change="updateFileDetails()"  -->
                         <input id="file2minify" placeholder="videoInputPlaceholderText"  @change="handleImageMinify"
                            style="max-width:50%;margin:auto;;margin-top:2px;" class="form-control" type="file" ref="file" accept="image/*">
 <p class="col-2" ></p>
                        </div>
            <div class="col-12" v-if="videoOption">
                    <div class="row d-flex justify-content-center">
                      <label class="col-2 text-right" for="videourl">(Valid) Video URL:&nbsp;</label>
                        <input style="max-width:50%;margin:auto;margin-top:2px;" class="col-6 form-control" v-model="videourl" type="text"/>
                        <button :disabled="videourl=='' && videourl.length >20" class="btn btn-warning btn-sm" @click="vaidateVideoURL()">Step 1: Validate Video URL</button>
                    </div>
                    <span v-html="validationResults()"></span>
                </div>


                    <div style="visibility:block;">
          <div class="row d-flex justify-content-center mt-2">
                      <label class="col-2 text-right" for="videourl"> Headline :</label><input style="max-width:50%;margin:auto;" class="col-6 form-control" v-model="slice_headline" type="text"/>
<small class="col-2 text-red" v-if="slice_headline && slice_headline.length< 20">increase headline length.</small>

            </div>
                        <!-- :initial-value="" -->
                    <h5 class="modal-title text-bold">Your story, You today:</h5>
                    <myStoryInput ref="vizInp"
                        :api-key="apikey"
                        cloud-channel="6"
                        :disabled=false
                        id="myStoryInputID"
                        :init= "getInitMenuPlugins()"
                        :inline=false
                        model-events= ""
                        :placeholder="showofforumModel.initial"
                        plugins=""
                        tag-name="div"
                        toolbar=""
                        value=""
                        name="mystory"
                        v-model="showofforumModel.story"
                    />
                    </div>
                    <button class="btn btn-lg btn-warning float-right mx-2 my-2" @click="cancel">Close</button>
<!-- {{ (!this.videoOption && !(!file_name ||!asset ||this.slice_headline.length< 20 || this.showofforumModel.story.length < 40)) }}<br/>
 {{(!this.videoOption) }}|{{  !file_name }}|{{!asset}} |{{this.slice_headline.length< 20}}|{{  this.showofforumModel.story.length < 40}} -->
                    <button :disabled="(!this.videoOption && (!name ||!asset ||this.slice_headline.length< 20 || this.showofforumModel.story.length < 40))"
                            class="btn btn-lg btn-primary float-right  mx-2 my-2" @click="submitData">Save All
                    </button> <!--!(this.videoOption && this.videourlvalid)|| -->
                    </div>
                </div>
                <div id="canvasContainer">
                    <canvas ref="resizedCanvas"></canvas>
                </div>
 <div style="margin-top:8px;" id="imageDisplay"></div>
<!-- Last updated: {{timeslice.updated_at}} -->
 <!-- {{this.$refs.file.files[0]}} -->
            </div></div></div></div>

</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import EventBus from '../../event-bus';
import Editor from '@tinymce/tinymce-vue';



import { v4 as uuidv4 } from 'uuid';

export default {
    components: {
    myStoryInput: Editor,
     },
    name: "ShowofforumMinifyCreate",
    data() {
        return {
            csrf_token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            userinfo:'',
            showofforumModel:{story:'', initial: ''},
            id:'',
            timeslice: {},
            apiKey:'',
            step: 0,
            videoOption:false,
            visual_option:'image',
            videourlvalid: '',
            videourl:'',
            slice_headline: '',
            asset:'',
            file_name: '',
            display_title: '',
            saved_timeslice:'',
            name:'',
            resizedImage:'',
            imgQuality: 70,

        }
    },

    props: {
        userdata:'',
        templates:[],
        apikey:'',
    },
    mounted() {

//   this.alltemplates = JSON.parse(this.templates);
        EventBus.$on('displayShowOffMinifyCreateModal', (data) => {
            console.log("displayShowOffMinifyCreateModal invoked");
            // this.modalReset();
            this.userinfo = data.userdata;
            // console.log('apikey: ' + this.apikey);
            $('div#create-timeslice-minify-modal').modal('show');
        });
        this.showofforumModel={initial:this.initial, story: ''};
    },
    methods: {
        checkImageSelected(){
            return  this.$refs.file.files[0].name || this.$refs.file.files[0];
        },
        updateFileDetails(){
            this.name =  this.$refs.file.files[0].name;
            this.asset = this.$refs.file.files[0];
        },
        permitSaveAll() {
            console.log(this.videoOption + " " + this.videourlvalid);
            console.log(this.videoOption + " " + this.file != '');
            console.log(this.showofforumModel.story.length);
            return ((this.videoOption && this.videourlvalid)|| (!this.videoOption && this.file != '')) && this.showofforumModel.story.length > 10;
        },
        handleImageMinify() {
            this.updateFileDetails();
            console.log("HandleImageMinify Step 1....");
            const input = this.$refs.file;
            const canvas = this.$refs.resizedCanvas;
            if (input.files && input.files[0]) {
                console.log("Step 2....");
                const reader = new FileReader();
                reader.onload = (e) => {
                    console.log("Reader onLoad....");
                    const image = new Image();
                    image.src = e.target.result;
                    console.log("Got image.src....");
                    image.onload = () => {
                        // canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');
                        console.log("Got ctx....");

                        // Set the canvas dimensions to the desired size
                        canvas.width = 600; // Adjust this width as needed
                        canvas.height = (image.height / image.width) * canvas.width;
                        this.canvasHeight = canvas.height;
                        this.canvasWidth = canvas.width;

                        // Draw the image on the canvas
                        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                        console.log("Drew image....");
                        // Determine the original image type
                        const originalType = this.getImageType(input.files[0].type);

                        // Convert the canvas content to a data URL with the original image type
                        this.resizedImage = canvas.toDataURL(originalType, this.imgQuality);
                        // Convert the canvas content to a data URL
                        // this.resizedImage = canvas.toDataURL('image/jpeg', this.imgQuality);
                        console.log("Draw image completed...");
                    };
                };
                reader.readAsDataURL(input.files[0]);
                this.uploadFile();
            }
        },
        getImageType(fileType) {
            // Map common image MIME types to corresponding file extensions
            const mimeToExtension = {
            'image/jpeg': 'jpg',
            'image/png': 'png',
            'image/gif': 'gif',
            // Add more if needed
            };

            // Use the mapped extension or default to 'jpg'
            return mimeToExtension[fileType] || 'jpg';
        },
        uploadFile() {
            console.error('uploadFile invoked...');
            this.asset = this.$refs.file.files[0];
            // this.submitFile();
        },
        updateFileDetails(){
            // this.name =  this.$refs.file.files[0].name;
            this.name =  this.$refs.file.files[0].name;
            this.display_title = this.$refs.file.files[0].name;
            this.description = this.$refs.file.files[0].name;
            this.enableInputNameField(false);
        },
        enableInputNameField(boolVal){
            document.getElementById('file2minify').disabled = boolVal;
        },



        submitData() {

              if(this.visual_option == 'image') {
                this.asset = this.$refs.file.files[0];
                this.file_name =  this.$refs.file.files[0].name;
              }
            if(this.asset && this.name && this.slice_headline && this.showofforumModel.story){
                console.error('submitFile invoked...');
                var url = '/showofforum/timeslice/save';
                const formData = new FormData();
                //const fs = require ('fs');  fs.createReadStream(file);
                if(this.visual_option == 'image') {
                        formData.append('file', this.resizedImage);
                        formData.append('filename', this.file_name);
                }
                formData.append('headline', this.slice_headline);
                formData.append('text', this.showofforumModel.story);
                formData.append('visual_option', this.visual_option);
                if(this.visual_option == 'video') formData.append('videourl', this.videourl);
                const csrf =  document.querySelector('meta[name="csrf-token"]').getAttribute('content');
                // console.log("csrf: " + csrf);
                const headers = {
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': csrf,
                    'Content-Type': 'multipart/form-data',
                };

                axios.post(url, formData, {headers })
                .then  ((response) => {
                    this.timeline = JSON.parse(JSON.stringify(response.data.timeslice));
                    this.updateToast(response.data.message, 5000, 'success');
                }).catch((err)=>{
                    console.error(err.message);
                    this.updateToast(err.message, 5000, 'error');
                }).finally(()=> {
                    console.log('done saving/updating timeslice...');
                    EventBus.$emit('refreshShowofforumHome', {});
                });
            } else {
                var missingData = this.findMissingTimeSliceData();
                this.updateToast(missingData, 7000, 'error');
            }
        },

        findMissingTimeSliceData() {
            var retVal = '';
            if(!this.$refs.file.files[0] || !this.$refs.file.files[0].name) {
                return "Please check an Image is selected for upload";
            }
            if(!this.slice_headline){
                return "Please insert a Headline statement (below the Upload image input)";
            }
            if(!this.showofforumModel.story) {
                return "Please write some sentences as Your story, today";
            }
        },

        checkVimeoURL(videoURL) {
            var retval = false;
            fetch(`https://vimeo.com/api/oembed.json?url=${videoURL}`)
            .then(response => {
                if (!response.ok) {
                    // Invalid URL
                    retval = false;
                    // throw new Error('Invalid URL');
                    console.error("Invalid Vimeo url: " + videoURL);
                } else {
                    // valid URL
                    retval = true;
                    this.videourlvalid = true;  //FLAG AS TRUE FROM HERE DUE TO RESPONSE DELAY
                    console.log(response);
                }
            })
            .catch(err => {
            // Invalid URL
                retval = false;
                console.error(err);
            });
            return retval;
        },
        // isVimeoURL(url) {//DODGY
        // // return /^(http\:\/\/|https\:\/\/)?(www\.)?(vimeo\.com\/)([0-9]+)$/.test(url);
        // // return /^(http\:\/\/|https\:\/\/)?(vimeo\.com\/)([0-9]+)$/.test(url);
        // // return /https:\/\/vimeo.com\/\d{8,}(?=\b|\/)/.test(url);
        // return (?:https?\:\/\/)?(?:www\.)?(?:vimeo\.com\/)([0-9]+).test(url);
        // },
        isYTUrl(url) {
            var p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
            if(url.match(p)){
                return url.match(p)[1];
            }
            return false;
        },
        setVisualType(){
            // this.enableInputNameField(true);
            // this.file_path =  '';
            // if(this.visual_option ==='image') this.width = this.height = 0;
            // this.selectedImage = this.selectedURL = '';
            // this.dropImage();
        },
        dropImage() {
                document.getElementById('imageDisplay').innerHTML = '';
        },
        switchVideoImg() {
            this.videoOption = !this.videoOption;
            if(this.videoOption == true) this.visual_option = 'video';
            if(this.videoOption == false) this.visual_option = 'image';
        },
        vaidateVideoURL() {
            console.log("Validating: " + this.videourl)
            var isVim, isYT = false;
            // if (this.isYTUrl(this.videourl) || this.checkVimeoURL(this.videourl)) {
            var isYT =   this.isYTUrl(this.videourl);
            // console.log(isYT);
            console.error("YTVideo: " + isYT);
            if(isYT == false) isVim = this.checkVimeoURL(this.videourl);
            console.log("VIMVideo? " + isVim);
            if(!isYT && !isVim) {
                this.videourlvalid = false;
                this.step = 0;//don't permit to progress to submission.
                console.log("Returning false and exiting...");
                return false;
            } else {
                if(isYT) {
                    var videoID = this.videourl.split("v=")[1].substring(0, 11);
                     console.log("returning true " + videoID);
                    // return this.checkYTValidity(videoID);  // Cant do without a google API (chargeable)  TODO later....
                    this.videourlvalid = true;
                    return true;
                }
                if(isVim) {
                    if(this.checkVimeoURL(this.videourl)) {
                        this.videourlvalid = true;
                        return true;
                    }
                    return false;
                }
            }
        },
        validationResults() {
            var retval = '';
            if (this.videoOption && (this.videourl !='' && (this.videourlvalid != '' && !this.videourlvalid))) {
                retval = "<small>Invalid Video URL.  Please check URL and re-validate.</small>";
            }else {
                retval = `<small>Video URL has a valid format.</small>`;
            }
        },
        getTodayFormat() {
            return new Date().toDateString();
        },
        saveStep() {


        },
        checkYTValidity(videoID) {
            var retval = false;
            axios.get(`https://www.googleapis.com/youtube/v3/videos?id=`+videoID)
            .then(response => {
            if (!response.ok) {
                // Invalid URL
                throw new Error('Invalid URL');
            } else {
                // valid URL
                retval = true;
                console.log(response);
            }
            })
            .catch(err => {
            // Invalid URL
                console.error(err);
            });
            console.log("checkYTValidity " + retval)

            // res.constructor.name; // 'Object', means `res` is a POJO
            // // `res.data` contains the parsed response body
            // res.data; // { args: { answer: 42 }, ... }
            // res.data instanceof Object; // true
            return retval;
            // doc page: https://developers.google.com/youtube/v3/docs/videos/list
    },
         myStoryInputID() {
            var guid = uuidv4();
            // console.log("GUID: " + guid);
            return guid;
        },
        modalReset() {
            //set all fields to blank
        },
        cancel() {
            // console.log("Cancel close FSLifeArea");
            //reset all variables:
            this.videourl = '';
            this.file = '';
            this.videoOption = false;
            this.showofforumModel.story ='';
            // document.getElementById('videoImageSwitch').checked = false;  ///until video timeslice reinstated
            this.visual_option = 'image';
            $('div#create-timeslice-modal').modal('hide');
            EventBus.$emit('refreshDashPage');
        },
        getTemplate(life_area) {
             console.log("Looking for template with id " + life_area);
            return this.templates.find((template) =>{
                    // console.log(life_area + ' : '+ template.life_area);
                if(template.life_area == life_area) {
                    // console.log("Found template...");
                    return template;
                }
            });
        },
        getInitMenuPlugins() {
            return {
                height: 200,
                menubar: false,
                plugins: [
                    'code table lists'
                ],
                toolbar:
                    'blocks undo redo | formatselect | bold italic backcolor | \
                    alignleft aligncenter alignright | \
                    bullist numlist outdent indent | removeformat | help'
            }
        },
        saveAction() {
            this.saveDetails();
        },

        saveDetails() {
            axios.post('/showofforum/timeslice/save', {
                user_id:this.userinfo.id,
                title:this.slice_title,
                text:this.timeslice.vision,
                videourl:this.timeslice.url,
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.updateToast(this.message, 4000);
                console.error(res.data.message);
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                // this.success = false;

            })
            .finally(()=> {
                // location.reload();
            });

        },
        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },

    },
    computed: {
        initial() {
            var retval = `2-3 sentences: Where I am today (what's good, what I want to grow/improve). Basically: My goals for Me in my shorter/longer future`;
            return retval;
        },
        videoInputPlaceholderText() {
        return "https://youtubeOrVimeo.com/videoIDGoesHere/etc";
        }
    },
}
</script>
<style>
.bg-custom{
    background: #449acb;
color: #fff;
}
</style>
